import * as React from "react";
import { Form as AntForm } from "antd";
import { withFormik, FormikProps, Field, Form } from "formik";
import { NormalizedErrorMap } from "@njoy/controller";
import { resetPasswordSchema } from "@njoy/common";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import NewButton from "../../../../components/uiMerge/newButton"
import { BackButton } from "../../../../components/uiMerge/backButton";
import ToastMessage from "../../../../hooks/useToast";
import { extractError } from "../../../../utils/extractError";

import { InputField } from "../../../shared/InputField";

const FormItem = AntForm.Item;

interface FormValues {
  email: string;
}

interface Props {
  onFinish: () => void;
  submit: (values: FormValues) => Promise<NormalizedErrorMap | null>;
}

class C extends React.PureComponent<FormikProps<FormValues> & Props> {
  render() {

    return (
      <>
        <ToastContainer />

        <div className='flex flex-col items-center min-h-screen w-full px-[1rem]'>
          <div className='flex flex-row justify-between items-center flex-nowrap w-full mt-12 '>
            <BackButton onClick={() => window.history.back()} />
            <p className=' text-[20px] text-center text-white mx-auto'>
              Forgot Password
            </p>

          </div>
          <div className="w-full flex flex-col mt-12 flex-1">
            <Form className="flex flex-col h-full flex-1" onSubmit={this.props.handleSubmit}>
            
                
                  <label className="text-white p-1 opacity-[80%]" htmlFor="email"> Email Address</label>
                  <Field
                    name="email"
                    placeholder="Email Address"
                    component={InputField}
                  />
                
                <div className="mt-auto">
                  <FormItem >
                    <NewButton
                      loading={this.props.isSubmitting}
                      fullWidth
                      variant="primary"
                      type="submit"
                      className="login-form-button"
                    >
                      Reset Password
                    </NewButton>
                  </FormItem>
                </div>
            
            </Form>
          </div>
        </div>
      </>
    );
  }
}

export const ForgotPasswordView = withFormik<Props, FormValues>({
  validationSchema: resetPasswordSchema,
  mapPropsToValues: () => ({ email: "" }),
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {
    try {
      setSubmitting(true);
      const serverErrors = await props.submit(values);

      if (serverErrors) {
        setSubmitting(false);
        ToastMessage("error", extractError(serverErrors));
        setErrors(serverErrors);
        return;
      }

      setSubmitting(false);
      props.onFinish();
    } catch (error: any) {
      setSubmitting(false);
      ToastMessage("error", (error as Error)?.message);
    }
  }
})(C);
